import React, { useEffect, useRef } from 'react';
import { CountUp } from 'countup.js';

function AnimatedCounter({ end = 1000, duration = 2.5, prefix = '', suffix = '' }) {
  const spanRef = useRef(null);

  useEffect(() => {
    if (spanRef.current) {
      const options = { duration, prefix, suffix };
      const cp = new CountUp(spanRef.current, end, options);
      if (!cp.error) {
        cp.start();
      } else {
        console.error(cp.error);
      }
    }
  }, [end, duration, prefix, suffix]);

  return <span ref={spanRef}>0</span>;
}

export default AnimatedCounter;
